<template>
  <div class="table-responsive">
    <table class="table table-bordered table-striped table-hover">
      <thead>
        <tr>
          <th>
            Wax
          </th>
          <th v-for="columnName in columnNames" :key="columnName">
            {{ columnName }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="waxGroup in waxGroups">
          <tr :key="waxGroup.name">
            <td class="wax-group-name" :colspan="columnNames.length + 1">
              {{ waxGroup.name }}
            </td>
          </tr>
          <template v-for="wax in waxGroup.waxes">
            <tr :key="`${wax.name}-1`">
              <td :rowspan="wax.rowsRequired">
                {{ wax.name }}
              </td>
              <wick-cell
                v-for="columnName in columnNames"
                :key="wickKey(wax, columnName)"
                :wick="wax.findWick(columnName).firstRow"
              />
            </tr>
            <template v-if="wax.rowsRequired === 2">
              <tr :key="`${wax.name}-2`">
                <wick-cell
                  v-for="columnName in columnNames"
                  :key="wickKey(wax, columnName)"
                  :wick="wax.findWick(columnName).secondRow"
                />
              </tr>
            </template>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import WickCell from './wick-cell.vue'

  export default {
    components: {
      WickCell
    },
    props: {
      waxGroups: { type: Array, required: true },
      columnNames: { type: Array, required: true }
    },
    methods: {
      wickKey(wax, columnName) {
        return `${wax.name}-${columnName}`
      }
    }
  };
</script>
